import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Typography, Space } from 'antd'
import DocumentLink from '../../components/DocumentLink'
import Section from '../../components/Layout/Section'

import styles from './Cgu.module.scss'

const { Title } = Typography

export const Accessibility: FC = () => {
    const { t } = useTranslation('accessibility')

    return (
        <Section className={`text-align-justify ${styles.cguDetails}`} >
            <div className={styles.container}>
                <div className={styles.cguDetails}>
                    <Title level={1}>
                        {t('title')}
                    </Title>

                    {/* Main content */}
                    <div
                        className={styles.readBloc}
                        dangerouslySetInnerHTML={{
                            __html: t('content.text'),
                        }}
                    />

                    {/* Document Links Section */}
                    <div style={{ marginTop: '32px' }}>
                        <Title level={3}>{t('documents.title')}</Title>
                        <Space direction="vertical" size="middle">

                            <DocumentLink
                                documentType="accessibility-action-plan"
                                actionType="open"
                            >
                                {t('documents.actionPlan')}
                            </DocumentLink>

                            <DocumentLink
                                documentType="accessibility-multiannual-scheme"
                                actionType="open"
                            >
                                {t('documents.multiannualScheme')}
                            </DocumentLink>
                        </Space>
                    </div>
                </div>
            </div>
        </Section>
    )
}

export default Accessibility
